import useInterval from '~/hooks/useInterval';

import styles from './styles';

const progressSpeeds = {
  superfast: 60,
  fast: 30,
  normal: 5,
};

const LoadingBar = ({ classes, className, speed, currentPercentage = 100 }) => {
  const [percentage, setPercentage] = useState(0);
  const progressSpeed = progressSpeeds[speed] || progressSpeeds['normal'];

  useInterval(() => {
    if (percentage < currentPercentage) {
      let newPercentage = percentage + progressSpeed;

      if (newPercentage > currentPercentage) {
        newPercentage = currentPercentage;
      }

      setPercentage(newPercentage);
    }
  }, 1000);

  return (
    <div className={classnames(className, classes.loadingBarWrapper)}>
      <div
        className={classes.loadingBarInner}
        style={{ width: percentage + '%' }}
      />
    </div>
  );
};

LoadingBar.defaultProps = {
  speed: 'normal',
};

LoadingBar.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  speed: PropTypes.oneOf(Object.keys(progressSpeeds)),
  currentPercentage: PropTypes.number,
};

export default withStyles(styles)(LoadingBar);
